import React, { Component } from "react";
import "./../../../assests/styles/CreditLinesBodyStyle.css";
import cross from "./../../../assests/img/cross.png";
import tick from "./../../../assests/img/tick.png";
import Popover from "@material-ui/core/Popover";
import CreditTransactionApiHandler from "./../CreditTransactionApiHandler.js";

const datefor = new Intl.DateTimeFormat("en-GB", {
	year: "numeric",
	month: "short",
	day: "2-digit"
});

export default class CreditTransactionsItem extends Component {
	constructor(props) {
		super(props);
		this.state = {
			showDetails: false,
			editChequePopOver: false,
			anchorEl: null,
			newChequeNumber: '',
			error: null
		};
		this.myRef = React.createRef();
		this.myRef2 = React.createRef();
		this.myRef3 = React.createRef();
		this.copyToClipboard = this.copyToClipboard.bind(this);
		this.copyToClipboard2 = this.copyToClipboard2.bind(this);
		this.copyToClipboard3 = this.copyToClipboard3.bind(this);
		this.getTransactionTransition = this.getTransactionTransition.bind(this);
	}
	copyToClipboard(e) {
		const el = document.createElement("textarea");
		el.value = this.myRef.current.firstChild.data;
		document.body.appendChild(el);
		el.select();
		document.execCommand("copy");
		document.body.removeChild(el);
		e.stopPropagation();
		return;
	}

	copyToClipboard2(e) {
		const el = document.createElement("textarea");
		el.value = this.myRef2.current.firstChild.data;
		document.body.appendChild(el);
		el.select();
		document.execCommand("copy");
		document.body.removeChild(el);
		e.stopPropagation();
		return;
	}

	copyToClipboard3(e) {
		const el = document.createElement("textarea");
		el.value = this.myRef3.current.firstChild.data;
		document.body.appendChild(el);
		el.select();
		document.execCommand("copy");
		document.body.removeChild(el);
		e.stopPropagation();
		return;
	}

	editChequeNumber = (event) => {
		event.stopPropagation();
		this.setState({ anchorEl: event.currentTarget });
		this.setState({ editChequePopOver: true });
	}

	closePopOver = () => {
		this.setState({ newChequeNumber: '', editChequePopOver: false, error: null });
	}

	render() {
		return (
			<div className="CreditLineItem">
				<div onClick={() => this.setState({ showDetails: !this.state.showDetails })}>
					<div className="row">
						<div className="col-md-4">
							<div className="row">
								<div className="col-md-7"> {this.makeFirstCol()} </div>
								<div className="col-md-5"> {this.makeSecondCol()} </div>
							</div>
						</div>
						<div className="col-md-3"> {this.makeThirdCol()} </div>
						<div className="col-md-3"> {this.makeFourthCol()} </div>
						<div className="col-md-2"> {this.makeFifthCol()} </div>
					</div>
				</div>
				<div> {this.state.showDetails ? this.showDetails() : null} </div>
			</div>
		);
	}

	getSegregatedAmount(payList) {
		var obj = {
			base: 0,
			interest: 0,
			penalty: 0
		}
		for (var i in payList) {
			if (payList[i].paymentType === "BASE") {
				obj.base += payList[i].amount;
			} else if (payList[i].paymentType === "INTEREST") {
				obj.interest += payList[i].amount;
			} else if (payList[i].paymentType === "PENALTY") {
				obj.penalty += payList[i].amount;
			} else if (payList[i].paymentType === "CONVENIENCE_FEE") {
				obj.interest += payList[i].amount;
			} else if (payList[i].paymentType === "CONVENIENCE_FEE_TAX") {
				obj.interest += payList[i].amount;
			}
		}
		return obj;
	}

	getSegregatedAmountForRepaymentDetails(payList) {
		var obj = {
			base: 0,
			interest: 0,
			penalty: 0
		}
		for (var i in payList) {
			if (payList[i].paymentType === "BASE") {
				obj.base += payList[i].amount;
			} else if (payList[i].paymentType === "INTEREST") {
				obj.interest += payList[i].amount;
			} else if (payList[i].paymentType === "PENALTY") {
				obj.penalty += payList[i].amount;
			}
		}
		return obj;
	}


	showDetails() {
		var data = this.props.data;
		var payList = data.paymentInstrument.paymentDetailsList;
		var obj = this.getSegregatedAmount(payList);
		return (
			<div>
				<div className="row" style={{marginTop:'15px',marginLeft:'-8px'}}>
					<hr />
					<div className="col-md-2">
						<div className="lite">Repayment Type:</div>
						<div className="black">{data.paymentInstrument.paymentInstrumentName}</div>
						<div style={{ marginTop: "2px" }} className={"d-flex flex-row"}>
							<div className={"lite inline"}>Late Fee Penalty:</div>
							<div className={'inline black'}>{data.totalLateFeePenalty}</div>
						</div>

					</div>
					<div className="col-md-3" style={{ width: "20%" }}>
						<div>
							<div className="lite inline">Total Amount:</div>
							<div className="inline black">₹{data.totalAmount}</div>
						</div>
						<div>
							<div className="inline lite">Base:</div>
							<div className="inline black">₹{obj.base}</div>
						</div>
					</div>
					<div className="col-md-2" style={{ whiteSpace: 'nowrap' }}>
						{(data.isConvenienceFeeEnabled) ?
							<div className="lite inline">Conv. Fee + Tax:</div>
							:
							<div className="lite inline">Interest:</div>
						}
						<div className="black inline">₹{obj.interest.toFixed(2)}</div>
						<div>
							<div className="lite inline">Other Penalty:</div>
							<div className="black inline normal-font">
								{data.totalPenalty}
							</div>
						</div>
					</div>
					<div className="col-md-5">
						<div className="row">
							<div className="col-md-6">
								<div className="lite inline">Actual Date:</div>
								<div className="black inline normal-font">{data.actualRepaymentDate === null ? "N/A" : datefor.format(data.actualRepaymentDate)}</div>
							</div>
							<div className="col-md-6">
								<div className="lite inline">
									Ever Bounced:
								</div>
								<div className="red inline normal-font">{data.everBounced ? " Yes" : " No"}</div>
							</div>
						</div>
						<div className="row no-right-padding">
							<div className="col-md-6">
								<div className="lite inline">Bounce Penalty:</div>
								<div className="black inline normal-font">{data.totalPenalty}</div>
							</div>
							<div className="col-md-6">
								<div className="lite inline">Bounce Reason:</div>
								<div className="red inline normal-font">{data.bounceReason}</div>
							</div>
						</div>
					</div>
				</div>
				<div style={{ position: "relative", padding: "40px 0 25px 0", marginTop: "15px" }}>
					<div className="back-bar" />
					{this.getTransactionTransition()}
				</div>
				<div className="row">
					{data.repaymentDetailsList.length > 0 ? (
						<div className={""} style={{ width: "100%" }}>
							<hr />
							<div>{this.makeHeaderForRepaymentDetails()}</div>
							<div>{this.showRepaymentDetails()}</div>
						</div>
					) : null}
				</div>
			</div>
		);
	}

	makeHeaderForRepaymentDetails() {
		const { data } = this.props;
		return (
			<div style={{ padding: "0 0 0 20px" }}>
				<div className="black" style={{ marginBottom: "5px" }}>
					Repayment details: <span style={{ fontWeight: 'bold', opacity: '0.6' }}>(Total base and interest paid ₹ {data.totalPaidBaseAndInterest})</span>
				</div>
				<div className="row black">
					<div className="col-md-2">Txn ID</div>
					<div className="col-md-1">Mode</div>
					<div className="col-md-1">Total Amount</div>
					<div className="col-md-1">Base</div>
					<div className="col-md-1">Interest</div>
					<div className="col-md-1">Penalty</div>
					<div className="col-md-2">Ref Number</div>
					<div className="col-md-1">Date</div>
					<div className="col-md-2">CollectedBy</div>
				</div>
			</div>
		);
	}

	showRepaymentDetails() {
		var res;
		this.props.data.repaymentDetailsList.sort(function (a, b) {
			return a.transactionDate > b.transactionDate ? 1 : b.transactionDate > a.transactionDate ? -1 : 0;
		});
		res = this.props.data.repaymentDetailsList.map((repaymentDetail, key) => {
			if (repaymentDetail.repaymentDetailsList)
				var obj = this.getSegregatedAmountForRepaymentDetails(repaymentDetail.repaymentDetailsList);
			else
				obj = { base: "NA", penalty: "NA" };
			return (
				<div style={{ padding: "0 0 0 20px" }}>
					<div className="row lite repaymentDetailsDiv">
						<div className="col-md-2">{repaymentDetail.paymentInstrumentId}</div>
						<div className="col-md-1">{repaymentDetail.paymentMode}</div>
						<div className="col-md-1">{repaymentDetail.totalAmount}</div>
						<div className="col-md-1">{obj.base}</div>
						<div className="col-md-1">{obj.interest}</div>
						<div className="col-md-1">{obj.penalty}</div>
						<div className="col-md-2">{repaymentDetail.refId}</div>
						<div className="col-md-1">{datefor.format(repaymentDetail.transactionDate)}</div>
						<div className="col-md-2">{repaymentDetail.collectedBy}</div>
					</div>
				</div>
			);
		});
		return res;
	}

	makeFirstCol() {
		let data = this.props.data;
		return (
			<div className="firstcol">
				<div className="littleSpace">
					<div className="lite inline">{"Txn Id: "}</div>
					<div className="inline black" ref={this.myRef}>
						{data.paymentInstrument.paymentInstrumentId}
					</div>
					<div className="inline">
						<i className="far fa-copy" style={{ marginLeft: "5px" }} onClick={this.copyToClipboard} title="This is a tooltip." />
					</div>
				</div>
				<div className="littleSpace black" ref={this.myRef2}>
					{data.bzId}
					<div className="inline">
						<i className="far fa-copy" style={{ marginLeft: "5px" }} onClick={this.copyToClipboard2} />
					</div>
				</div>
				<div className="little lite" style={{marginLeft:'7px'}}>{data.storeName}</div>
			</div>
		);
	}
	makeSecondCol() {
		var resp;
		if (this.props.data.userDetailsList && this.props.data.userDetailsList.length > 0) {
			var data = this.props.data.userDetailsList[0];
			resp = (
				<div className="firstCol">
					<div className="littleSpace lite">{data.firstName}</div>
					<div className="littleSpace lite">{data.mobileNumber}</div>
				</div>
			);
		}
		return resp;
	}

	dueAmount(data) {
		return `${data.totalPendingAmount.toFixed(2)}`
	}

	makeThirdCol() {
		var data = this.props.data;
		var payList = data.paymentInstrument.paymentDetailsList;
		var obj = this.getSegregatedAmount(payList);


		return (
			<div className="firstCol">
				<div className="boxStyle littleSpace">{data.creditProductName}</div>
				<div className="centerThis littleSpace">
					<span style={{ opacity: "0.5" }}>Txn Amount:</span>
					<span className="green">₹ {(obj.base + obj.interest).toFixed(2)}</span>
				</div>
				<div className="centerThis littleSpace">

					<span style={{ opacity: "0.5" }}>Due Amount:</span>
					<span className="green">₹ {this.dueAmount(data)}</span>
				</div>
			</div>
		);
	}

	newChequeNumberChanged = event => {
		this.setState({ newChequeNumber: event.target.value, error: null });
	}

	chequeNumberChanged = () => {
		const { newChequeNumber } = this.state;
		const { data } = this.props;
		let r = {
			id: data.paymentInstrument.paymentInstrumentId,
			newChequeNumber: newChequeNumber
		}
		this.closePopOver();
		this.props.chequeNumberUpdated(r);
	}

	updateChequeNumber = () => {
		const { newChequeNumber } = this.state;
		const { data } = this.props;
		if (data.paymentInstrument.paymentReferenceId === newChequeNumber) {
			this.setState({ error: 'New and Old cheque number is same.' })
		} else {
			let req = { changeChequeDetailsList: [{ chequeId: data.paymentInstrument.paymentInstrumentId, oldChequeNumber: data.paymentInstrument.paymentReferenceId, newChequeNumber: newChequeNumber }] }
			CreditTransactionApiHandler.changeChequeNumber(req)
				.then(response => {
					if (response.changeSuccessfulChequeIds.length > 0) {
						this.chequeNumberChanged();
					} else {
						this.setState({ error: 'Failed to update cheque number' })
					}
				}).catch(error => {
					this.setState({ error: error })
				}).finally(() => {

				})
		}
	}

	makeFourthCol() {
		var data = this.props.data;
		const { editChequePopOver, anchorEl, newChequeNumber, error } = this.state;
		return (
			<div>
				<div className="littleSpace" style={{ position: 'relative' }}>
					<span style={{ opacity: "0.5" }}>{data.paymentInstrument.paymentInstrumentName}#:</span>
					<div className="inline black" ref={this.myRef3}>
						{data.paymentInstrument.paymentReferenceId}
					</div>
					<div className="inline">
						<i className="far fa-copy" style={{ marginLeft: "5px" }} onClick={this.copyToClipboard3} />
					</div>
					{(data.paymentInstrument.paymentInstrumentName.includes('CHEQUE')) ?
						<div className="inline">
							<i className="fas fa-pencil-alt" style={{ marginLeft: "5px" }} onClick={this.editChequeNumber}></i>
						</div> : null
					}
					<Popover open={editChequePopOver} onClose={this.closePopOver} anchorEl={anchorEl} transition>
						<div style={{ padding: '20px 20px 10px 20px' }} onClick={(event) => { event.stopPropagation() }}>
							<div>Edit cheque number</div>
							<input type="text" pattern="\d*" maxlength="6" onChange={this.newChequeNumberChanged} value={newChequeNumber} style={{ border: '1px solid #dfdfdf', borderRadius: '2px', padding: '6px 10px', outline: 'none' }} />
							<div>{(error) ? <div className="error-text">{error}</div> : null}</div>
							<div style={{ marginTop: '10px', textAlign: 'right' }}><button className="btn btn-jt-ops" onClick={this.updateChequeNumber} disabled={newChequeNumber.length === 6 ? false : true}>Update</button></div>
						</div>
					</Popover>
				</div>
				<div className="littleSpace">
					<span style={{ opacity: "0.5" }}>Txn Date:</span>
					<span className="black">{datefor.format(data.transactionDate)}</span>
				</div>
				<div className="littleSpace">
					<span style={{ opacity: "0.5" }}>Repayment Date:</span>
					<span className="black">{datefor.format(data.dueDate)}</span>
				</div>
			</div>
		);
	}
	makeFifthCol() {
		let data = this.props.data;
		let status = data.paymentInstrumentStatus;
		let color;
		if (status === "BOUNCED") color = "red";
		else if (status === "CLEARED") color = "green";
		else if (status === "REPAID") color = "green";
		else if (status === "PAID") color = "green";
		else if (status === "CANCELLED") color = "red";
		else if (status === "COLLECTED") color = "green";
		else if (status === "IN_HUB" || status === "INITIATED") color = "yellow";
		else if (status === "PARTIALLY_REPAID") color = "red";
		else if (status === "WITH_COE") color = "yellow";
		else if (status === "INITIAL") color = "yellow";
		else if (status === "WITH_LOGICASH") color = "yellow";
		else if (status === "SUBMITTED_TO_BANK") color = "yellow";
		else if (status === "IN_OFFICE") color = "yellow";
		else if (status === "YET_TO_BE_DISBURSED") color = "yellow";
		else if (status === "DISBURSED") color = "yellow";
		else if (status === "DENIED") color = "red";
		return (
			<div>
				<div style={{ display: "flow-root" }}>
					<div className={color + "-status-box " + color} style={{ float: "right", padding: "5px" }}>
						{data.paymentInstrumentStatus}
					</div>
				</div>
				<div className="littleSpace" />
				<div style={{ display: "flow-root" }}>
					<div style={{ float: "right" }}>
						{data.daysPastDue ? (
							<div className="littleSpace">
								<div className="lite inline">DPD :</div>
								<div className="inline red">{" " + data.daysPastDue + " days"}</div>
							</div>
						) : null}
					</div>
				</div>
			</div>
		);
	}

	getTransactionTransition() {
		var txn = this.props.data;
		var trns;
		var trnsLine;
		var widSize = 20;
		var maxwid = 0;
		if (txn) {
			var transitions = txn.paymentInstrument.paymentInstrumentStatusTransitionList;
			if (transitions.length > 5) {
				widSize = 100 / transitions.length;
			}
			trns = transitions.map((item, index) => {
				maxwid = index * widSize;
				return (
					<div style={{ left: index * widSize + "%", position: "absolute", top: "0" }}>
						<div className="smallFont" style={{ marginTop: "10px" }}>
							{item.status}
						</div>
						<div className="status-circle">
							{item.status === "BOUNCED" || item.status === "OVER_DUE" || item.status === "DENIED" ? <img src={cross} alt="cross" style={{ height: "20px", width: "20px", marginTop: "-3px" }} /> : null}
							{item.status === "CLEARED" || item.status === "REPAID" || item.status === "PAID" ? <img src={tick} alt="tick" style={{ height: "20px", width: "20px", marginTop: "-3px" }} /> : null}
						</div>
						<div className="smallFont" style={{ marginTop: "30px" }}>
							{datefor.format(item.transitionOccurredDate)}
						</div>
					</div>
				);
			});
			trnsLine = <div className="inner-bar" style={{ width: maxwid + "%" }} />;
		}
		return [trns, trnsLine];
	}
}



// WEBPACK FOOTER //
// ./src/screens/creditTransactions/components/creditTransactionsItem.js